import { Component } from '@theme/component';

class CollectionGrid extends Component {
  #list;
  #status;
  #sectionId;

  connectedCallback() {
    super.connectedCallback();
    this.#list = this.querySelector('[data-grid-list]');
    this.#status = this.querySelector('[data-grid-status]');
    this.#sectionId = this.dataset.sectionId;
    this.addEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const button = event.target.closest('[data-grid-more-btn]');
    if (!button) return;
    event.preventDefault();
    this.#loadMore(button);
  };

  async #loadMore(button) {
    const url = button.getAttribute('href');
    if (!url || this.hasAttribute('aria-busy')) return;
    this.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');

    try {
      const separator = url.includes('?') ? '&' : '?';
      const response = await fetch(`${url}${separator}section_id=${this.#sectionId}`);
      if (!response.ok) throw new Error(response.status);
      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const nextList = parsed.querySelector('[data-grid-list]');
      const nextMore = parsed.querySelector('[data-grid-more]');

      if (nextList) {
        const firstNewIndex = this.#list.children.length;
        const fragment = document.createDocumentFragment();
        while (nextList.firstElementChild) fragment.appendChild(nextList.firstElementChild);
        this.#list.appendChild(fragment);
        this.#list.children[firstNewIndex]?.querySelector('a')?.focus();
        if (this.#status) this.#status.textContent = this.dataset.loadedText;
      }

      const currentMore = this.querySelector('[data-grid-more]');
      if (nextMore) {
        currentMore?.replaceWith(nextMore);
      } else {
        currentMore?.remove();
      }
    } catch {
      window.location.href = url;
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('collection-grid-component')) {
  customElements.define('collection-grid-component', CollectionGrid);
}

const mobileQuery = matchMedia('(max-width: 767px)');

class CollectionFilterbar extends Component {
  #sortMenu;
  #sortToggle;

  connectedCallback() {
    super.connectedCallback();
    this.#sortMenu = this.querySelector('[data-sort-menu]');
    this.#sortToggle = this.querySelector('[data-sort-toggle]');
    this.#sortToggle?.addEventListener('click', this.#toggleSort);
    this.querySelector('[data-drawer-open="filter"]')?.addEventListener('click', this.#anchorFilterDrawer);
    document.addEventListener('click', this.#onDocumentClick);
    document.addEventListener('keydown', this.#onKeydown);
  }

  #anchorFilterDrawer = () => {
    const drawer = document.querySelector('[data-drawer="filter"]');
    if (!drawer) return;
    if (!mobileQuery.matches) {
      drawer.style.removeProperty('--drawer-top');
      return;
    }
    drawer.style.setProperty('--drawer-top', `${Math.round(this.getBoundingClientRect().bottom)}px`);
  };

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this.#onDocumentClick);
    document.removeEventListener('keydown', this.#onKeydown);
  }

  #setSort(open) {
    if (!this.#sortMenu) return;
    const fuocoDentro = !open && this.#sortMenu.contains(document.activeElement);
    this.#sortMenu.toggleAttribute('hidden', !open);
    this.#sortToggle.setAttribute('aria-expanded', String(open));
    if (fuocoDentro) this.#sortToggle.focus();
  }

  #toggleSort = () => this.#setSort(this.#sortMenu?.hasAttribute('hidden'));

  #onDocumentClick = (event) => {
    if (this.#sortMenu?.hasAttribute('hidden')) return;
    if (!event.target.closest('[data-sort]')) this.#setSort(false);
  };

  #onKeydown = (event) => {
    if (event.key === 'Escape' && !this.#sortMenu?.hasAttribute('hidden')) this.#setSort(false);
  };
}

if (!customElements.get('collection-filterbar-component')) {
  customElements.define('collection-filterbar-component', CollectionFilterbar);
}
